import { OnInit, Component, Input, EventEmitter, Output, OnChanges, ViewChild, ElementRef, AfterViewInit, DoCheck, ChangeDetectorRef, HostListener } from '@angular/core';
import { CartItemService } from './card-item.service';
import { IBaseCampaignDto, ICampaignErrorMessageDto, IPlatformBuildStatusJson, IUserPropertiesDto } from '@Workspace/_generated/interfaces';
import { Constants } from '@Workspace/common';
import { eAccountType, eBuildErrorType, eCampaignStatus, eUserRole } from '@Workspace/_generated/enums';
import { AuthService } from '@Workspace/auth';
import { faCircleCheck, faCircleExclamation, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { ConfirmationService } from 'primeng/api';

@Component({
    selector: 'card-item',
    templateUrl: './card-item.component.html',
    styleUrls: ['./card-item.component.scss']
})
export class CardItemComponent implements OnInit, AfterViewInit {
    isContentArray: boolean;
    @Input('header') set header(value: string) { this._header = value; }
    @Input('content') set content(value: [any]) { this._content = value; }
    @Input('editButton') editButton: boolean = false;
    @Input() isNoteValid: boolean = true;
    @Input() baseCampaign: IBaseCampaignDto = {} as IBaseCampaignDto;
    @Input() isShareOfVoice: boolean = false;
    @Input() statusId: eCampaignStatus;
    @Input() platformBuildStatusJson: IPlatformBuildStatusJson;
    @Input() campaignErrorMessages: ICampaignErrorMessageDto[];
    @Input() campaignStatusId: eCampaignStatus;
    @Input() campaignType: eAccountType;

    @Output() onEdit = new EventEmitter();

    @Input('cardType') cardType: "generic" | "social" | "landingPage" | "inventoryAddOn" | "contact" | "advertiser" | "keyValuePair" | "additionalSettings" | "paymentStatus" | "unlockFeatures" | "geographics" | "demographics" | "metaAdAccount" = "generic";

    @ViewChild('contactDiv', { static: false }) contactDiv!: ElementRef;
    @ViewChild('contactSpan', { static: false }) contactSpan!: ElementRef;

    additionalSettingChanged: boolean = false;
    demographicsChanged: boolean = false;
    geographicsChanged: boolean = false;
    paymentStatusChanged: boolean = false;
    @Input() contactInfo: string = null;
    constants = Constants;
    enumAccountType = eAccountType;
    showIcon: boolean = null;
    isIconVisible: boolean = false;
    advertiserArray: any[] = [];
    currentUser: IUserPropertiesDto = this.authService.userSettings;
    faCircleCheck: any = faCircleCheck;
    faCircleXmark: any = faCircleXmark;
    faCircleExclamation: any = faCircleExclamation;
    enumUserRole = eUserRole;
    enumCampaignStatus = eCampaignStatus;

    constructor(private cardItemService: CartItemService, private cdr: ChangeDetectorRef, 
        private authService: AuthService,
        private confirmationService: ConfirmationService,) { }


    ngOnInit(): void {

        if (this.cardType == 'geographics') {
            var geoArray = this._content as string[];
            this.geographicsChanged = geoArray.some(x => x != "");
        }
        if (this.cardType == 'demographics') {
            var demoArray = this._content as string[];
            this.demographicsChanged = demoArray.some(x => x != "");
        }
        if(this.cardType == 'advertiser' || this.cardType == 'metaAdAccount') 
            this.advertiserArray = (this._content as string[]).slice();
        this.isContentArray = Array.isArray(this._content);
    }

    ngAfterViewInit() {
        this.checkContactWidths();
      }
      
    
    @HostListener('window:resize', ['$event'])
        onResize(event: any) {
        this.checkContactWidths();
    }

    public hasDate = false;
    public _header: string;
    public _content: string | [string];
    public _flipped: boolean;

    editClicked(value: string) {
        this.onEdit.emit(value);
        if (value == 'Additional Settings') {
            this.additionalSettingChanged = true;

        } else if (value == 'Demographics') {
            this.demographicsChanged = true;
        }
        else if (value == 'Georaphical targeting') {
            this.geographicsChanged = true;
        }
        else if (value == 'Payment status') {
            this.paymentStatusChanged = true;
        }
    }

    checkContactWidths() {
        if(!!this.contactDiv || !!this.contactSpan){
            const divWidth = this.contactDiv.nativeElement.offsetWidth;
            const spanWidth = this.contactSpan.nativeElement.offsetWidth;
        
            if (spanWidth >= divWidth) {
                if(!this.isIconVisible){
                    this.isIconVisible = true;
                    this.cdr.detectChanges();
                }
              } else {
                if(this.isIconVisible){
                    this.isIconVisible = false;
                    this.cdr.detectChanges();
                }
              } 
        }
        else{
            this.isIconVisible = false;
        }
    }

    campaignStatusIcon(){
        if(this.statusId == eCampaignStatus.Build_Success)
            return {'label': 'faCircleCheck','key': this.faCircleCheck};
        else if(this.statusId == eCampaignStatus.Build_Failed)
            return {'label': 'faCircleXmark','key': this.faCircleXmark};
        else if (this.statusId == eCampaignStatus.Build_Partial_Success)
            return {'label': 'faCircleExclamation','key': this.faCircleExclamation};
        else
            return null;
    }

    //Method to show campaign status message.
    campaignStatusMessage(){
        let platformBuildStatusJson: IPlatformBuildStatusJson = this.platformBuildStatusJson;
        let errorMessages = [];

        if(platformBuildStatusJson != null){
            let dv360ErrorMessages = this.campaignErrorMessages
                .filter(x => x.buildErrorType === eBuildErrorType.DV360BuildCampaign)
                .sort((a, b) => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime())[0];
            let reinitiateMessage = "";

            let ttdErrorMessages = this.campaignErrorMessages
                .filter(x => x.buildErrorType === eBuildErrorType.TTDBuildCampaign)
                .sort((a, b) => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime())[0];

            if (
                this.statusId === eCampaignStatus.Build_Partial_Success &&
                ((platformBuildStatusJson.dV360BuildStatusId === eCampaignStatus.Build_Failed &&
                dv360ErrorMessages?.message &&
                (
                    dv360ErrorMessages.message.includes("Syncing creatives from GCM still in progress") ||
                    dv360ErrorMessages.message.includes("HttpStatusCode is InternalServerError. Internal error encountered")
                )) || (platformBuildStatusJson.ttdBuildStatusId === eCampaignStatus.Build_Failed && ttdErrorMessages?.message &&
                    ttdErrorMessages.message.includes("An internal service error has occurred")
                ))
            ) {
                reinitiateMessage = "! HUB will attempt to rebuild the campaign automatically every 3 hours.";
            }

            //GCM
            if (platformBuildStatusJson.gcmBuildStatusId === eCampaignStatus.Build_Failed) {
                errorMessages.push({
                    message: "GCM Build: Build Failed"
                });
                const errorMessage = this.campaignErrorMessages.find(x => x.buildErrorType === eBuildErrorType.GCMBuildCampaign);
                if (errorMessage) errorMessages.push(errorMessage);
            }
            else if (platformBuildStatusJson.gcmBuildStatusId === eCampaignStatus.Build_Success) {
                errorMessages.push({
                    message: "GCM Build: Build Success"
                });
            }

            //DV360
            if (platformBuildStatusJson.dV360BuildStatusId === eCampaignStatus.Build_Failed) {
                errorMessages.push({
                    message: "DV360 Build: Build Failed"
                });
                const errorMessage = this.campaignErrorMessages.find(x => x.buildErrorType === eBuildErrorType.DV360BuildCampaign);
                if (errorMessage) errorMessages.push(errorMessage);
            }
            else if (platformBuildStatusJson.dV360BuildStatusId === eCampaignStatus.Build_Success) {
                errorMessages.push({
                    message: "DV360 Build: Build Success"
                });
                const errorMessage = this.campaignErrorMessages.find(x => x.buildErrorType === eBuildErrorType.DV360BuildCampaign);
                if (errorMessage) errorMessages.push(errorMessage);
            }

            //TTD
            if (platformBuildStatusJson.ttdBuildStatusId === eCampaignStatus.Build_Failed) {
                errorMessages.push({
                    message: "TTD Build: Build Failed"
                });
                const errorMessage = this.campaignErrorMessages.find(x => x.buildErrorType === eBuildErrorType.TTDBuildCampaign);
                if (errorMessage) errorMessages.push(errorMessage);
            }
            else if (platformBuildStatusJson.ttdBuildStatusId === eCampaignStatus.Build_Success) {
                errorMessages.push({
                    message: "TTD Build: Build Success"
                });
            }

            //GAM
            if (platformBuildStatusJson.gamBuildStatusId === eCampaignStatus.Build_Failed) {
                errorMessages.push({
                    message: "GAM Build: Build Failed"
                });
                const errorMessage = this.campaignErrorMessages.find(x => x.buildErrorType === eBuildErrorType.GAMBuildCampaign);
                if (errorMessage) errorMessages.push(errorMessage);
            }
            else if (platformBuildStatusJson.gamBuildStatusId == eCampaignStatus.Build_Success) {
                errorMessages.push({
                    message: "GAM Build: Build Success"
                });
                const errorMessage = this.campaignErrorMessages.find(x => x.buildErrorType === eBuildErrorType.GAMBuildCampaign);
                if (errorMessage) errorMessages.push(errorMessage);
            }

            //Meta
            if (platformBuildStatusJson.metaBuildStatusId === eCampaignStatus.Build_Failed) {
                errorMessages.push({
                    message: "META Build: Build Failed"
                });
                errorMessages.push(this.campaignErrorMessages.find(x => x.buildErrorType === eBuildErrorType.METABuildCampaign));
            }
            else if (platformBuildStatusJson.metaBuildStatusId === eCampaignStatus.Build_Success) {
                errorMessages.push({
                    message: "META Build: Build Success"
                });
            }
            this.confirmationService.confirm({
                header: 'Campaign Build Messages',
                key: 'campaignErrorMessage',
                message: `
                <div class="rebuild-message">${reinitiateMessage}</div>
                <div class="Dv360-warning-message ${reinitiateMessage ? '' : 'dv360-only'}">
                    ${(this.campaignType == eAccountType.FAN365 && platformBuildStatusJson.dV360BuildStatusId != null)
                        ? 'DV360 requires the Creative Type to be set manually. Open this campaign in DV360 and set it under Campaign Settings before it can serve.'
                        : ''}
                </div>
                <ul style="padding-left: 1px;">
                    ${errorMessages
                            .map((error, index) => {
                                return error.message.split(';')
                                    .map((line) => {
                                        let formattedLine = line.trim();
                                        if (formattedLine.includes('Build Failed') || formattedLine.includes('Build Success')) {
                                            return `${((formattedLine.includes('Build Failed') || formattedLine.includes('Build Success')) && index > 0) ? '<br>' : ''}<strong class="custom-list">${formattedLine}</strong>${(formattedLine.includes('Build Success')) ? '<br>' : ''}`;
                                        }
                                        return `<li class="custom-list-item">${formattedLine}</li>`;
                                    })
                                    .join('');
                            })
                            .join('')}
                </ul>
                `,
                rejectVisible: false,
                acceptVisible: false,
                rejectLabel: 'Close',
                reject: () => {
                    this.confirmationService.close();
                }
            });
        }
        
    }

    getBuildStatusesTooltip(){
        let platformBuildStatusJson: IPlatformBuildStatusJson = this.platformBuildStatusJson;
        if(platformBuildStatusJson == null)
            return;

        if(platformBuildStatusJson.dV360BuildStatusId == eCampaignStatus.Build_Failed || platformBuildStatusJson.gcmBuildStatusId == eCampaignStatus.Build_Failed
        || platformBuildStatusJson.gamBuildStatusId == eCampaignStatus.Build_Failed || platformBuildStatusJson.ttdBuildStatusId == eCampaignStatus.Build_Failed
        || platformBuildStatusJson.metaBuildStatusId == eCampaignStatus.Build_Failed)
        {
            let tooltipString = '';

            if (!!platformBuildStatusJson.gcmBuildStatusId) {
                let buildStatus: string = platformBuildStatusJson.gcmBuildStatusId == eCampaignStatus.Build_Failed ? 'Build Failed' : 'Build Success';
                tooltipString += 'GCM Status: ' + buildStatus + '\n';
            }
            if (!!platformBuildStatusJson.dV360BuildStatusId) {
                let buildStatus: string = platformBuildStatusJson.dV360BuildStatusId == eCampaignStatus.Build_Failed ? 'Build Failed' : 'Build Success';
                tooltipString += 'DV360 Status: ' + buildStatus + '\n';
            }
            if (!!platformBuildStatusJson.ttdBuildStatusId) {
                let buildStatus: string = platformBuildStatusJson.ttdBuildStatusId == eCampaignStatus.Build_Failed ? 'Build Failed' : 'Build Success';
                tooltipString += 'TTD Status: ' + buildStatus + '\n';
            }
            if (!!platformBuildStatusJson.gamBuildStatusId) {
                let buildStatus: string = platformBuildStatusJson.gamBuildStatusId == eCampaignStatus.Build_Failed ? 'Build Failed' : 'Build Success';
                tooltipString += 'GAM Status: ' + buildStatus + '\n';
            }
            if (!!platformBuildStatusJson.metaBuildStatusId) {
                let buildStatus: string = platformBuildStatusJson.metaBuildStatusId == eCampaignStatus.Build_Failed ? 'Build Failed' : 'Build Success';
                tooltipString += 'META Status: ' + buildStatus + '\n';
            }
            return tooltipString;
        }
        else
        {
            let tooltipString = '';
            if(!!platformBuildStatusJson.gcmBuildStatusId){
                tooltipString += 'GCM Status: Build Success\n';
            }
            if(!!platformBuildStatusJson.dV360BuildStatusId){
                tooltipString += 'DV360 Status: Build Success\n';
            }
            if(!!platformBuildStatusJson.ttdBuildStatusId){
                tooltipString += 'TTD Status: Build Success\n';
            }
            if(!!platformBuildStatusJson.gamBuildStatusId){
                tooltipString += 'GAM Status: Build Success\n';
            }
            if(!!platformBuildStatusJson.metaBuildStatusId){
                tooltipString += 'META Status: Build Success\n';
            }
            return tooltipString;
        }
    }

     getActivationTooltip(): string {
         switch (this.campaignType) {
            case this.enumAccountType.FAN365:
                return 'Requires Start & End Dates, Player NIL, and School IP selection to save as Yes. Add the CampaignID override in the Reports section to enable automated reporting.';
            case this.enumAccountType.OAS:
                return 'Requires Start & End Dates to save as Yes. Add the CampaignID override in the Reports section to enable automated reporting.';
            case this.enumAccountType.Social:
                return 'Requires Start & End Dates to save as Yes.';
            default:
                return '';
        }
    }
}
